import * as React from 'react';
import { classes, st } from './Image.deprecated.st.css';
import { WowImage } from '../WowImage/WowImage';
/** Image is a component to literally display an image - whether an absolute with full URL or a media platform item with relative URI */
export class Image extends React.Component {
    render() {
        const { className, ...imageProps } = this.props;
        return React.createElement(WowImage, { className: st(classes.root, className), ...imageProps });
    }
}
//# sourceMappingURL=Image.js.map